/** A moment as the person reads it: a date and a time, in their language. */
export function readingDate(iso: string, locale: string): string {
  const moment = new Date(iso)
  if (!iso || Number.isNaN(moment.getTime())) return ''
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(moment)
}
